import {
  Directive,
  ElementRef,
  Renderer2,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[rxTokenToDiv]',
})
export class TokenToDivDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver;
  private contentChange = new Subject<string>();

  @HostListener('input')
  onInputChange() {}

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    this.contentChange.pipe(debounceTime(300)).subscribe(() => this.convertTokensToDivs());

    this.observer = new MutationObserver((mutations) => {
      let contentChanged = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          contentChanged = true;
        }
      });

      if (contentChanged) {
        this.contentChange.next(this.el.nativeElement.innerHTML);
      }
    });

    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.contentChange.complete();
  }

  private convertTokensToDivs() {
    this.observer.disconnect(); // Temporarily disconnect the observer

    let processedContent = this.el.nativeElement.innerHTML;
    const tokenRegex = /#(.*?)#/g;
    processedContent = processedContent.replace(
      tokenRegex,
      (match, token) => ` <div contenteditable="false" class="non-editable-token">${token}</div> `,
    );

    if (processedContent !== this.el.nativeElement.innerHTML) {
      this.el.nativeElement.innerHTML = processedContent;
      console.log('New HTML:', this.el.nativeElement.innerHTML);
    }

    console.log('Observer reconnecting');
    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    this.cd.detectChanges();
  }
}
